//CSS
import '../../Components/Page/Page.css'
import './POCAssemballyVid.css';
//React
import React, { useEffect, useState } from 'react';
import useAPI from '../../Hooks/useAPI';
import SecHeader from '../../Components/SecHeader/SecHeader';



const POCAssemballyVid: React.FC = () => {
    const { getNewsOtp } = useAPI();
    const [error, setError] = useState<string>('');
    const [source, setFile] = useState<string | null>(null);

    useEffect(() => {
        const fetchOpt = async () => {
            try {
                const body = await getNewsOtp();

                console.log("news video Response data:", body);
                const src = `https://player.vdocipher.com/v2/?otp=${body.otp}&playbackInfo=${body.playbackInfo}`
                setFile(src); // Assuming data is a File or Blob
            } catch (err) {
                setError(err instanceof Error ? err.message : 'An error occurred');
            }
        };

        fetchOpt();
    }, [getNewsOtp]);

    return (
        <div id="OPTVideo" className='sectionContainer OTPVid'>
            <SecHeader title="Internals Proof of Concept Assembly" />
            {source !== null && <iframe
                className='OPTVideo1'
                src={source}
                allow="encrypted-media"
            // allowFullScreen
            ></iframe>}
        </div>
    );
};

export default POCAssemballyVid;